import { IContentSource } from "../../domain/drawing";
import { IClipboardAccessible, IClipboardWatchable } from "../../domain/system";

export class ClipboardAccessor implements IClipboardAccessible {
  constructor(public readonly textWatcher: IClipboardWatchable<string>, public readonly imageWatcher: IClipboardWatchable<IContentSource>) {
  }
}
